/* eslint-disable eslint-comments/disable-enable-pair */

/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { maestroApiCall } from '@michelin/central-provider';
import {
  FetchCustomTireSizeAspectRatiosParams,
  FetchCustomTireSizeDiametersParams,
  FetchCustomTireSizeLoadsParams,
  FetchCustomTireSizeSizesParams,
  FetchCustomTireSizeSpeedRatingsParams,
} from '@michelin/core-profile-ui-tools/build/components/UFOVehicleDetailsForm/types';
import { SelectOption } from '@michelin/select-options-provider';
import hash from 'object-hash';
import { useQueryClient } from 'react-query';
import { customTireSizeAPIType } from 'types/APITypes';
import { buildOptionsAndValuesFromArray, buildOptionsAndValuesFromSpeedRatings } from './Utils';

export const useGetCustomSizes = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchCustomTireSizeSizesParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetCustomSizes', hash(params)],
        () => maestroApiCall(customTireSizeAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromArray(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

export const useGetCustomAspectRatios = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchCustomTireSizeAspectRatiosParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetCustomAspectRatios', hash(params)],
        () => maestroApiCall(customTireSizeAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromArray(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

export const useGetCustomDiameters = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchCustomTireSizeDiametersParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetCustomDiameters', hash(params)],
        () => maestroApiCall(customTireSizeAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromArray(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

export const useGetCustomLoads = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchCustomTireSizeLoadsParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetCustomLoads', hash(params)],
        () => maestroApiCall(customTireSizeAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromArray(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

export const useGetCustomSpeedRatings = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchCustomTireSizeSpeedRatingsParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetCustomSpeedRatings', hash(params)],
        () => maestroApiCall(customTireSizeAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromSpeedRatings(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};
